module.exports = __webpack_public_path__ + "img/logo-baton.f2b40d7.png";